import { render, staticRenderFns } from "./instructorProcessMenus.vue?vue&type=template&id=65030536&scoped=true"
import script from "./instructorProcessMenus.vue?vue&type=script&lang=js"
export * from "./instructorProcessMenus.vue?vue&type=script&lang=js"
import style0 from "./instructorProcessMenus.vue?vue&type=style&index=0&id=65030536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65030536",
  null
  
)

export default component.exports